import { message } from "antd";
import { BaseResponseHeader } from "../generated";

export const isSuccess = (header: BaseResponseHeader) => {
  const isSuccess = header.isSuccess;
  if (isSuccess) {
    return true;
  }
  const resultMessage = header.resultMessage || "";
  console.log({ resultMessage });
  message.error(resultMessage);
  
};
